export default "__VITE_ASSET__CxPJ3OMI__"